import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import { ClipConfigProps, ClipStepsControlProps } from "../../clip-menu";
import { useState } from "react";
import { RecentClips } from "./recent-clips";
import { ClipConfiguration } from "../../models";
import { MAX_CLIPS } from "./new-clip";

interface HistoricClipsProps {
  onExit: () => void;
}

export const HistoricClips = (
  props: ClipConfigProps & ClipStepsControlProps & HistoricClipsProps,
) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const filteredClips: ClipConfiguration[] = props.clips.filter((clip) =>
    clip.name.toLowerCase().startsWith(search.toLowerCase()),
  );

  const totalPages = Math.ceil(filteredClips.length / MAX_CLIPS);

  const paginatedClips: ClipConfiguration[] = filteredClips.slice(
    MAX_CLIPS * (page - 1),
    MAX_CLIPS * page,
  );

  return (
    <>
      <h5 className="text-lg font-medium">Search</h5>
      <div className="flex flex-col gap-1 mb-2">
        <Input
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          placeholder="Search"
        />
      </div>
      <div className="flex justify-start">
        <Button variant="ghost" onClick={props.onExit}>Back</Button>
      </div>
      <RecentClips
        onSelect={(clip: ClipConfiguration) => {
          props.setClipConfig(clip);
        }}
        maxClips={props.clips.length}
        clips={paginatedClips}
        mapRef={props.mapRef}
        draw={props.draw}
      />
      {!search && totalPages > 1 && (
        <div className="self-center mt-auto flex">
          <Pagination>
            <PaginationContent>
              <PaginationItem>
                <PaginationPrevious
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  className={page === 1 ? "pointer-events-none opacity-50" : "cursor-pointer"}
                />
              </PaginationItem>
              {Array.from({ length: totalPages }, (_, i) => (
                <PaginationItem key={i + 1}>
                  <PaginationLink
                    onClick={() => setPage(i + 1)}
                    isActive={page === i + 1}
                    className="cursor-pointer"
                  >
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem>
                <PaginationNext
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  className={page === totalPages ? "pointer-events-none opacity-50" : "cursor-pointer"}
                />
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        </div>
      )}
    </>
  );
};
